// Copyright (C) 2017-2022 Smart code 203358507

const Board = require('./Board');

module.exports = Board;
